import {
  EDomainCountry,
  EDomainCountryId,
  EDomainCurrency,
  EDomainCurrencySymbol,
  EDomainValue,
} from '../../core/enums/domain.enum';
import { IWhitelabel } from '../../core/interfaces/whitelabel';
import { LITHUANIAN_EXAMPLES } from './ai-examples.const';

export const WHITE_LABELS: IWhitelabel[] = [
  {
    value: EDomainValue.LITHUANIA,
    countryId: EDomainCountryId.LITHUANIA,
    countryName: EDomainCountry.LITHUANIA,
    aiExamples: LITHUANIAN_EXAMPLES,
    currency: EDomainCurrency.LITHUANIA,
    currencySymbol: EDomainCurrencySymbol.LITHUANIA,
  },
];
